import { Breakpoint, Color, FontWeight, Markdown } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const MainContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
`;

export const Segment = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  background-color: ${Color.White};

  @media ${Breakpoint.Tablet} {
    padding: 24px;
  }
`;

export const StyledMarkdown = styled(Markdown)`
  strong {
    font-weight: ${FontWeight.Bold};
  }
`;
